import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardUserType as BasicPointCardUserType } from 'types/pointCard/pointCardUser'

type PointCardUserType = BasicPointCardUserType & { ref: FirebaseDocRefType }

const PointCardUserConverter = getConverter<PointCardUserType>()

export const fetchPointCardUser = (pointCardId: string, id: string): Promise<PointCardUserType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_users')
    .doc(id)
    .withConverter(PointCardUserConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardUsers = (pointCardId: string): Promise<PointCardUserType[]> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_users')
    .withConverter(PointCardUserConverter)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const setPointCardUser = (pointCardUser: PointCardUserType): Promise<void> => {
  const { ref, ...rest } = pointCardUser
  return ref.set(rest, { merge: true })
}
